/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, propTypes, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';
import { Button, Row, Col } from 'reactstrap';
// import Phone from 'material-ui/svg-icons/communication/phone';
import LocationOn from 'material-ui/svg-icons/communication/location-on';
import ExitToAppIcon from 'material-ui/svg-icons/action/exit-to-app';

import { TextFormGroup, validators as V } from 'components/Forms';
import scheduleAsessment from 'services/eloqua';
import dataLayerPush from 'services/dataLayer';

const FORM_NAME = 'scheduleAssessment';
const formSelector = formValueSelector(FORM_NAME);
const SUBMIT_BUTTON_LABEL = 'Send Your Request';
const SUBMIT_BUTTON_LABEL_LOADING = 'Sending...';

const ScheduleAssessment = ({ handleSubmit, valid, submitting, requestButtonLabel }) => (
  <div id="schedule-assessment" className="schedule-assessment">
    <h4 className="schedule-assessment__header">Take the Next Step</h4>
    <p className="schedule-assessment__copy">Provide your contact information and a Cummins Authorized Representative will be in touch with you to schedule your free in-home assessment.</p>
    <form className="schedule-assessment__form" onSubmit={handleSubmit}>
      <Row>
        <Col xs={12} md={6}>
          <Field
            name="firstName"
            component={TextFormGroup}
            type="text"
            placeholder="First Name*"
            validate={[V.required]}
          />
        </Col>
        <Col xs={12} md={6}>
          <Field
            name="lastName"
            component={TextFormGroup}
            type="text"
            placeholder="Last Name*"
            validate={[V.required]}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Field
            name="email"
            component={TextFormGroup}
            type="text"
            placeholder="Email*"
            validate={[V.required]}
          />
        </Col>
        <Col xs={12} md={6}>
          <Field
            name="phone"
            component={TextFormGroup}
            type="text"
            placeholder="Phone"
          />
        </Col>
      </Row>
      <Button
        disabled={!valid || submitting}
        type="submit"
        color="primary"
      >
        {requestButtonLabel}
      </Button>
    </form>
    <div className="schedule-assessment__contact-info">
      <p>Not ready for a visit yet? Contact us to learn more.</p>
      <div>
        {/* <a className="schedule-assessment__contact-info-link" href="tel:800-286-6467"> */}
        {/*  <Phone className="schedule-assessment__contact-info-icon" /> 1-800-CUMMINS */}
        {/* </a> */}

        <a className="schedule-assessment__contact-info-link" rel="noopener noreferrer" target="_blank" href="https://www.cummins.com/na/generators/residential/how-to-buy">
          <ExitToAppIcon className="schedule-assessment__buy-online-icon" /> Buy Online
        </a>
        <a className="schedule-assessment__contact-info-link" rel="noopener noreferrer" target="_blank" href="https://www.cummins.com/na/generators/residential/find-a-dealer">
          <LocationOn className="schedule-assessment__contact-info-icon" /> Locate a Dealer
        </a>
      </div>
    </div>
  </div>
);

ScheduleAssessment.propTypes = {
  ...propTypes,
  requestButtonLabel: PropTypes.string.isRequired,
};

const formConfig = {
  form: FORM_NAME,
};


if (process.env.NODE_ENV === 'development') {
  formConfig.initialValues = {
    firstName: 'Test',
    lastName: 'Testman',
    phone: '123-456-7890',
    email: 'eschoellhorn+test@352inc.com',
  };
}

const enhance = compose(
  connect(
    (state) => {
      const { location } = state;
      return {
        eloquaData: {
          zipCode: location.zipCode,
          state: location.state,
          country: (location.country && location.country.toLowerCase() === 'usa' ? 'United States' : location.country),
          firstName: formSelector(state, 'firstName'),
          lastName: formSelector(state, 'lastName'),
          phone: formSelector(state, 'phone'),
          email: formSelector(state, 'email'),
        },
      };
    },
  ),
  withState('requestButtonLabel', 'setButtonLabel', SUBMIT_BUTTON_LABEL),
  withHandlers({
    onSubmit: ({ eloquaData, setButtonLabel }) => () =>
      setButtonLabel(SUBMIT_BUTTON_LABEL_LOADING) ||
      scheduleAsessment(eloquaData)
        .then(() => {
          setButtonLabel(SUBMIT_BUTTON_LABEL);
          const payload = {
            event: 'powerNeedsQuote',
            zipCode: eloquaData.zipCode,
            state: eloquaData.state,
            country: eloquaData.country,
          };
          dataLayerPush(payload);
        })
        .catch(() => setButtonLabel(SUBMIT_BUTTON_LABEL)),
  }),
  reduxForm(formConfig),
);

export default enhance(ScheduleAssessment);



// WEBPACK FOOTER //
// ./src/views/Home/components/ScheduleAssessment.js